/**
 * Created by marlon.jerez on 10/07/2016.
 */
import {sideNavModel} from "./sideNavModel"
import * as Backbone from "Backbone"

export class sideNavView extends Backbone.View<sideNavModel> {

}


